import React, { useState, useEffect, useContext } from "react";
import { NavLink } from "react-router-dom";
import { getFinData } from "../../api/api";
import { UserContext } from "../../contexts/CurrentUserContext";
import "./Subheader.css";

const SubHeader = ({ tabs, showRefreshButton }) => {
  const { userData } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [availableYears, setAvailableYears] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  const hasAccessToRefresh =
    userData?.access_levels?.some((level) => level.name === "АДМС") ||
    userData?.id === 63;

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const years = [];
    // Генерируем массив доступных лет от 2023 до следующего года
    for (let year = 2023; year <= currentYear + 1; year++) {
      years.push(year);
    }
    setAvailableYears(years);
  }, []);

  const handleRefresh = async () => {
    try {
      setIsLoading(true);
      await getFinData(selectedYear);
      setShowPopup(true);
      // Автоматически скрываем попап через 3 секунды
      setTimeout(() => {
        setShowPopup(false);
      }, 3000);
    } catch (error) {
      console.error("Ошибка при обновлении данных:", error);
      alert(`Ошибка при обновлении данных: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="subheader">
      <div className="subheader__tabs">
        {tabs.map((tab) => (
          <NavLink
            key={tab.id}
            to={tab.path}
            className={({ isActive }) =>
              isActive
                ? "subheader__button subheader__button-active"
                : "subheader__button"
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
      {showRefreshButton && hasAccessToRefresh && (
        <div className="subheader__refresh-wrapper">
          <div className="subheader__refresh-container">
            <select
              className="subheader__year-select"
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
              disabled={isLoading}
            >
              {availableYears.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
            <button
              className="subheader__refresh-button"
              onClick={handleRefresh}
              disabled={isLoading}
            >
              {isLoading ? "Обновление..." : "Обновить данные"}
            </button>
          </div>
          <div className="subheader__warning">
            * Обновление данных может занять до 5 минут
          </div>
        </div>
      )}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <div className="popup-icon"></div>
            <p className="popup-text">Данные успешно обновлены</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubHeader;
